import "./modules/oxg.js"
import {oxgFnByName} from './modules/fn-by-name.js'
import "./modules/form-like.js"
import {oxgGenerateUniqueId, oxgIdIsUnique} from './modules/generate-unique-id.js'
import {for_each_in} from "./modules/arrays.js"
import {map} from "./modules/arrays.js" 
import {filter} from "./modules/arrays.js"
import "./modules/main-menu.js"
import "./modules/cart-flyout.js"
import "./modules/intersection-observer.js"
import "./modules/vimeo.js"
import "./modules/lazyImages.js"
import "./modules/tooltips.js"
import "./modules/forms.js"
import "./modules/show-more-less.js"
import "./modules/status-bar.js"
import "./modules/modals.js"

const jq = jQuery
window.oxgQueryString = window.location.search;
window.oxgUrlParams = new URLSearchParams(oxgQueryString)

window.oxgRemoveUrlParams = (paramsToRemove)=> {
  var urlParams = new URLSearchParams(window.oxgQueryString);
  paramsToRemove.forEach(param => {
      urlParams.delete(param);
  });
  var url = new URL(window.location.href);
  url.search = urlParams.toString();
  window.history.replaceState({}, document.title, url.href);
}

/* ------------------------------------------------------------------------------------------------------------------
--------------------------------------------------------------------- View Port Height
------------------------------------------------------------------------------------------------------------------ */

const adjustVphEl = ()=> {
  const vph = document.querySelector('.vph')
  if(!vph) return
  const adminBar = document.getElementById('wpadminbar')
  let adminBarHeight = adminBar ? adminBar.offsetHeight : 0
  const header = document.getElementById('oxg-header')
  let headerHeight = header ? header.offsetHeight : 0
  const footer = document.getElementById('oxg-footer')
  let footerHeight = footer ? footer.offsetHeight : 0
  const titleArea = document.getElementById('oxg-title-area')
  let titleAreaHeight = titleArea ? titleArea.offsetHeight : 0
  const statusBar = document.getElementById('oxg-status-bar')
  let statusBarHeight = statusBarHeight ? statusBar.offsetHeight : 0
  let targetHeight = window.innerHeight - adminBarHeight - headerHeight - footerHeight - titleAreaHeight - statusBarHeight
  vph.style.minHeight = targetHeight > 600 ? targetHeight + 'px' : '300px'
}

function oxgVph() {
  window.addEventListener('resize', ()=> {
    requestAnimationFrame(adjustVphEl)
  })
  adjustVphEl()
}

/* ------------------------------------------------------------------------------------------------------------------
--------------------------------------------------------------------- DOM Loaded
------------------------------------------------------------------------------------------------------------------ */

/* ANCHOR ---- DOM Loaded -------------------------- */

document.addEventListener('DOMContentLoaded', () => {

  console.log(performance.now() + ': DOM Content loaded')
  const mainJsEvent = new Event('mainJsLoaded');
  document.dispatchEvent(mainJsEvent);
  oxgVph()

  /* ------------------------------------------------------------------------------------------------------------------
  --------------------------------------------------------------------- Window Loaded
  ------------------------------------------------------------------------------------------------------------------ */

  /* ANCHOR ---- Window Loaded -------------------------- */

  window.onload = function() {
      console.log(performance.now() + ': window loaded')

      //log all global variables and functions to the console
      /* for (var b in window) {
          if (window.hasOwnProperty(b)) console.log(b)
      }*/

  }

});